module.exports = __webpack_public_path__ + "img/B04.b237091c.png";